// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCurrencies (params?: {}): Promise<List>;
    publicGetCandlesticksInstrumentCode (params?: {}): Promise<Dict>;
    publicGetFees (params?: {}): Promise<List>;
    publicGetInstruments (params?: {}): Promise<List>;
    publicGetOrderBookInstrumentCode (params?: {}): Promise<Dict>;
    publicGetMarketTicker (params?: {}): Promise<List>;
    publicGetMarketTickerInstrumentCode (params?: {}): Promise<Dict>;
    publicGetTime (params?: {}): Promise<Dict>;
    privateGetAccountBalances (params?: {}): Promise<Dict>;
    privateGetAccountFees (params?: {}): Promise<Dict>;
    privateGetAccountOrders (params?: {}): Promise<Dict>;
    privateGetAccountOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetAccountOrdersClientClientId (params?: {}): Promise<Dict>;
    privateGetAccountOrdersOrderIdTrades (params?: {}): Promise<Dict>;
    privateGetAccountTrades (params?: {}): Promise<Dict>;
    privateGetAccountTradeTradeId (params?: {}): Promise<Dict>;
    privatePostAccountOrders (params?: {}): Promise<Dict>;
    privateDeleteAccountOrders (params?: {}): Promise<List>;
    privateDeleteAccountOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteAccountOrdersClientClientId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
